<div class="header">
  <div class="d-flex">
      <gb-ui-header
          [imageDetail]="imageDetail"
          [showSearch]="true"
          [displayLinksBelow]="true"
          [navLinks]="navigation"
          (searchTerm)="search($event)"
        >
      </gb-ui-header>
  </div>
</div>
